import { z } from 'zod';
import { cohortTypeZodEnum } from '../../enum';

const cohortAndType = z.object({
  cohort: z.string(),
  cohortType: cohortTypeZodEnum(),
});
export const exportNewsletterReqDto = z.object({
  filter: z.array(cohortAndType).min(1),
});

export type ExportNewsletterReqDto = z.infer<typeof exportNewsletterReqDto>;
